import { DependencyList, useEffect, useRef } from 'react';

/**
 * Hook that runs a function only on component updates (not on mount)
 *
 * @param effect function to run on updates
 * @param deps array of dependencies
 */
export default function useDidMountEffect(effect: () => void, deps: DependencyList) {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      return effect();
    } else {
      didMount.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
